package com.macrofocus.eflux.ui.data

import com.macrofocus.common.selection.MutableSelection
import com.macrofocus.common.selection.MutableSingleSelection
import com.macrofocus.eflux.DataLoader
import com.macrofocus.eflux.network.logical.LogicalBusId
import mui.material.*
import mui.material.styles.Theme
import mui.material.styles.useTheme
import mui.system.sx
import org.mkui.react.useProperty
import react.FC
import react.Props
import react.ReactNode
import react.useRef
import web.cssom.FontFamily
import web.cssom.FontSize
import web.cssom.None
import web.timers.Timeout
import web.timers.clearTimeout
import web.timers.setTimeout
import kotlin.time.Duration.Companion.milliseconds

external interface SubstationChipProps : Props {
    var dataLoader: DataLoader
    var primary: Boolean?
    var probing: MutableSingleSelection<LogicalBusId>?
    var selection: MutableSelection<LogicalBusId>?
    var logicalBusId: LogicalBusId
    var placement: TooltipPlacement?
}

val SubstationChip = FC<SubstationChipProps> { props ->
    val theme = useTheme<Theme>()

    val dataLoader = props.dataLoader
    val controller = dataLoader.controller
    val logicalBusId = props.logicalBusId

    val (network, _) = useProperty(dataLoader.substationNetwork)
    val substation = network?.substations[logicalBusId]
    val (fullName, _) = useProperty(dataLoader.fullName)

    val clickTimer = useRef<Timeout>(null)

    if(substation != null) {
        Tooltip {
            title = if(fullName) ReactNode(substation.logicalBusId.name) else ReactNode(substation.name ?: substation.logicalBusId.name)
            placement = props.placement

            Chip {
                sx {
                    if(fullName) {
                        textTransform = None.none
                    } else {
                        fontFamily = "'JetBrains Mono', monospace".unsafeCast<FontFamily>()
                        fontSize = FontSize.small
                    }
                    backgroundColor = dataLoader.getColor(substation, theme)
                }

                variant = ChipVariant.outlined
                size = Size.small
                onPointerEnter = {
                    if(props.primary != null) controller.probeSubstation(substation.logicalBusId, props.primary!!)
                }
                onPointerLeave = {
                    if(props.primary != null) controller.probeSubstation(null, props.primary!!)
                }
                onClick = {
                    // cancel previous timer
                    clickTimer.current?.let {
                        clearTimeout(it)
                    }

                    // start new one
                    clickTimer.current = setTimeout(250.milliseconds)  {
                        dataLoader.overviewZoom(substation.logicalGeometry, substation.physicalGeometry)
                        if(props.primary != null) controller.selectSubstation(substation.logicalBusId, props.primary!!)
                    }
                }
                onDoubleClick = {
                    // cancel pending single click
                    clickTimer.current?.let { clearTimeout(it) }

                    dataLoader.physicalZoom(substation.physicalGeometry)
                    if(props.primary != null) controller.selectSubstation(substation.logicalBusId, props.primary!!)
                }
                label = if(!fullName) ReactNode(substation.logicalBusId.name) else ReactNode(substation.name ?: substation.logicalBusId.name)
            }
        }
    }
}